module.exports = __webpack_public_path__ + "img/question.15109754.svg";